var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from 'react';
import kfetch from '@kareo/kfetch';
import { Alert, Box, Button, Paper, PlusOutlinedIcon, Snackbar, Typography, } from '@kareo/design-system';
import styled from 'styled-components';
import SavedCardList from 'shared-assets/components/CreditCardDisplay/SavedCardList';
import { AddCardDialog } from 'shared-assets/components/PaymentSolutions/AddCardModal';
import NewCardForm from 'shared-assets/components/PaymentSolutions/NewCardForm';
import { GENERIC_SAVE_ERROR, getTransactionErrorMessage, getTransactionSetupId, isCardSaveSuccessful, isExpectedTransactionMessage, } from './transactionResult';
var CARD_REFRESH_ERROR = 'The card was saved, but the card list could not be refreshed. Please refresh the page.';
var INITIAL_FORM_STATE = {
    billingAddress1: '',
    billingCity: '',
    billingState: '',
    cardholderName: '',
    comments: '',
    nickname: '',
    usePatientAddress: false,
    zipCode: '',
};
function getInitialFormState(patientAddress, isFirstCard) {
    var _a, _b, _c, _d;
    if (isFirstCard === void 0) { isFirstCard = false; }
    var usePatientAddress = Boolean(patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode);
    return __assign(__assign({}, INITIAL_FORM_STATE), { billingAddress1: usePatientAddress ? (_a = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.address1) !== null && _a !== void 0 ? _a : '' : '', billingCity: usePatientAddress ? (_b = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressCity) !== null && _b !== void 0 ? _b : '' : '', billingState: usePatientAddress ? (_c = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressState) !== null && _c !== void 0 ? _c : '' : '', makeDefaultCard: isFirstCard, usePatientAddress: usePatientAddress, zipCode: usePatientAddress ? (_d = patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode) !== null && _d !== void 0 ? _d : '' : '' });
}
var CardManagementHeading = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    margin: 0;\n  }\n"], ["\n  && {\n    margin: 0;\n  }\n"])));
var INITIAL_TRANSACTION_SETUP = {
    isIframePresent: false,
    loading: false,
    transactionSetupId: null,
};
export function CardManagement(_a) {
    var _b = _a.cards, cards = _b === void 0 ? [] : _b, autoDefaultError = _a.autoDefaultError, config = _a.config, onAddCardCancelled = _a.onAddCardCancelled, onCardAdded = _a.onCardAdded, onDeleteCard = _a.onDeleteCard, onUpdateCard = _a.onUpdateCard, patientAddress = _a.patientAddress, patientId = _a.patientId;
    var _c = useState(cards), displayedCards = _c[0], setDisplayedCards = _c[1];
    var _d = useState(function () {
        return getInitialFormState(patientAddress, cards.length === 0);
    }), formState = _d[0], setFormState = _d[1];
    var _e = useState(cards.length === 0), isAddCardFormOpen = _e[0], setIsAddCardFormOpen = _e[1];
    var _f = useState(false), isAddCardDialogOpen = _f[0], setIsAddCardDialogOpen = _f[1];
    var _g = useState(null), saveError = _g[0], setSaveError = _g[1];
    var _h = useState(false), showSuccess = _h[0], setShowSuccess = _h[1];
    var setupRequestController = useRef(null);
    var transactionIframe = useRef(null);
    var _j = useState(INITIAL_TRANSACTION_SETUP), transactionSetup = _j[0], setTransactionSetup = _j[1];
    useEffect(function () {
        setDisplayedCards(cards);
    }, [cards]);
    useEffect(function () {
        if (!(patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode))
            return;
        setFormState(function (currentFormState) {
            var _a, _b, _c, _d;
            if (currentFormState.usePatientAddress || currentFormState.zipCode) {
                return currentFormState;
            }
            return __assign(__assign({}, currentFormState), { billingAddress1: (_a = patientAddress.address1) !== null && _a !== void 0 ? _a : '', billingCity: (_b = patientAddress.addressCity) !== null && _b !== void 0 ? _b : '', billingState: (_c = patientAddress.addressState) !== null && _c !== void 0 ? _c : '', usePatientAddress: true, zipCode: (_d = patientAddress.addressZipcode) !== null && _d !== void 0 ? _d : '' });
        });
    }, [
        patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.address1,
        patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressCity,
        patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressState,
        patientAddress === null || patientAddress === void 0 ? void 0 : patientAddress.addressZipcode,
    ]);
    function resetTransactionSetup() {
        var _a;
        (_a = setupRequestController.current) === null || _a === void 0 ? void 0 : _a.abort();
        setupRequestController.current = null;
        setIsAddCardDialogOpen(false);
        setTransactionSetup(INITIAL_TRANSACTION_SETUP);
    }
    function resetAddCard() {
        resetTransactionSetup();
        setFormState(getInitialFormState(patientAddress, displayedCards.length === 0));
    }
    useEffect(function () {
        if (!isAddCardDialogOpen || !transactionSetup.transactionSetupId) {
            return undefined;
        }
        var expectedTransactionSetupId = getTransactionSetupId(transactionSetup.transactionSetupId);
        if (!expectedTransactionSetupId)
            return undefined;
        function handleTransactionMessage(event) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var response, refreshedCards, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!isExpectedTransactionMessage(event, ((_a = transactionIframe.current) === null || _a === void 0 ? void 0 : _a.contentWindow) || null, expectedTransactionSetupId)) {
                                return [2 /*return*/];
                            }
                            response = (_b = event.data) === null || _b === void 0 ? void 0 : _b.response;
                            if (!response || typeof response.status !== 'string')
                                return [2 /*return*/];
                            resetTransactionSetup();
                            if (!isCardSaveSuccessful(response)) {
                                setSaveError(getTransactionErrorMessage(response));
                                setIsAddCardFormOpen(true);
                                return [2 /*return*/];
                            }
                            setFormState(getInitialFormState(patientAddress, displayedCards.length === 0));
                            setSaveError(null);
                            setIsAddCardFormOpen(false);
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, (onCardAdded === null || onCardAdded === void 0 ? void 0 : onCardAdded())];
                        case 2:
                            refreshedCards = _d.sent();
                            if (Array.isArray(refreshedCards)) {
                                setDisplayedCards(refreshedCards);
                            }
                            setShowSuccess(true);
                            return [3 /*break*/, 4];
                        case 3:
                            _c = _d.sent();
                            setSaveError(CARD_REFRESH_ERROR);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        window.addEventListener('message', handleTransactionMessage);
        return function () {
            return window.removeEventListener('message', handleTransactionMessage);
        };
    }, [
        isAddCardDialogOpen,
        displayedCards.length,
        onCardAdded,
        patientAddress,
        transactionSetup.transactionSetupId,
    ]);
    useEffect(function () {
        return function () { var _a; return (_a = setupRequestController.current) === null || _a === void 0 ? void 0 : _a.abort(); };
    }, []);
    function handleSubmit(form) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var abortController, transactionOptions, response, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setSaveError(null);
                        setIsAddCardDialogOpen(true);
                        (_a = setupRequestController.current) === null || _a === void 0 ? void 0 : _a.abort();
                        abortController = new AbortController();
                        setupRequestController.current = abortController;
                        setTransactionSetup({
                            isIframePresent: false,
                            loading: true,
                            transactionSetupId: null,
                        });
                        transactionOptions = {
                            billingAddress1: form.billingAddress1 || undefined,
                            billingCity: form.billingCity || undefined,
                            billingState: form.billingState || undefined,
                            billingZipcode: form.zipCode || undefined,
                            cardAccountId: Number(patientId),
                            cardDescription: form.comments || undefined,
                            cardNickname: form.nickname || undefined,
                            makeDefaultCard: Boolean(form.makeDefaultCard),
                            metadata: {
                                paymentScenario: 'card-management',
                            },
                            name: form.cardholderName,
                            paymentType: 3,
                            submissionType: 1,
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, kfetch("/payments-ui/api/PatientPay/payments-orchestrator-service/api/customer/lid/" + patientId + "/cards", {
                                body: JSON.stringify(transactionOptions),
                                method: 'POST',
                                signal: abortController.signal,
                            })];
                    case 2:
                        response = _d.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.transactionSetupId) ||
                            !getTransactionSetupId(response.transactionSetupId)) {
                            throw new Error(GENERIC_SAVE_ERROR);
                        }
                        setupRequestController.current = null;
                        setTransactionSetup({
                            isIframePresent: true,
                            loading: false,
                            transactionSetupId: response.transactionSetupId,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        if (((_b = error_1) === null || _b === void 0 ? void 0 : _b.name) === 'AbortError')
                            return [2 /*return*/];
                        resetTransactionSetup();
                        setSaveError(getTransactionErrorMessage(((_c = error_1) === null || _c === void 0 ? void 0 : _c.body) || error_1));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleCancel() {
        resetAddCard();
        setSaveError(null);
        setIsAddCardFormOpen(false);
        if (displayedCards.length === 0)
            onAddCardCancelled === null || onAddCardCancelled === void 0 ? void 0 : onAddCardCancelled();
    }
    function handleOpenAddCard() {
        setFormState(getInitialFormState(patientAddress, displayedCards.length === 0));
        setIsAddCardFormOpen(true);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { variant: "outlined" },
            React.createElement(Box, { padding: 3 },
                React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "space-between", marginBottom: 2 },
                    React.createElement(CardManagementHeading, { variant: "h3" }, "Payment Cards"),
                    React.createElement(Button, { color: "default", disabled: isAddCardFormOpen, onClick: handleOpenAddCard, size: "small", startIcon: React.createElement(PlusOutlinedIcon, null), variant: "contained" }, "Add a Card")),
                saveError && (React.createElement(Box, { marginBottom: 2 },
                    React.createElement(Alert, { variant: "filled", severity: "error" }, saveError))),
                autoDefaultError && (React.createElement(Box, { marginBottom: 2 },
                    React.createElement(Alert, { severity: "error", variant: "standard" }, autoDefaultError))),
                isAddCardFormOpen && (React.createElement(Box, { marginBottom: 2 },
                    React.createElement(NewCardForm, { config: {
                            showComments: true,
                            disableMakeDefaultCard: displayedCards.length === 0,
                            showMakeDefaultCard: true,
                            showNickname: true,
                            showUsePatientAddress: true,
                            requireBillingZip: false,
                            showFullBillingAddress: true,
                        }, formState: formState, onCancel: handleCancel, onSubmit: handleSubmit, patientAddress: patientAddress, setFormState: setFormState }))),
                displayedCards.length > 0 && (React.createElement(SavedCardList, { cards: displayedCards, config: config, onDeleteCard: onDeleteCard, onUpdateCard: onUpdateCard, parentManagesDeletedCards: true, patientAddress: patientAddress })))),
        React.createElement(AddCardDialog, { appearance: "card-on-file", iframeRef: transactionIframe, isIframePresent: transactionSetup.isIframePresent, isOpen: isAddCardDialogOpen, loading: transactionSetup.loading, onClose: resetAddCard, transactionSetupId: transactionSetup.transactionSetupId }),
        React.createElement(Snackbar, { autoHideDuration: 5000, message: "Card saved successfully.", onClose: function () { return setShowSuccess(false); }, open: showSuccess, type: "success" })));
}
export default CardManagement;
var templateObject_1;
